import React, { useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Upload } from 'antd';
import { API, sendDataBody } from '../../resources';

// PARENT: visitas.modal.jsx

// This component is used to put a estudio upload widget into visita.modal if estudio type is selected

export default function VisitaEstudio({ id_paciente, setIsModalOpen }) {

    const [fileUploaded, setFileUploaded] = useState(null)

    const props = {
        name: 'file',
        action: API + 'notas/estudios/upload',
        multiple: true,
        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (status === 'done') {
                message.success(`${info.file.name}: Archivo subido correctamente.`);
                console.log('New Files: ', info.file.response.file)
                setFileUploaded(info.file.response.file)
            } else if (status === 'error') {
                message.error(`${info.file.name}: Eror al subir el archivo.`);
            }
        },
    };

    const onConfirm = () => {
        if (!fileUploaded) {
            message.error('Debe seleccionar un archivo')
            return;
        }
        const body = { id_paciente, estudio: fileUploaded, tipo_visita: 'Estudio', }
        sendDataBody('visitas/add', body).then(res => {
            console.log('After create estudio visita res: ', res);
            setIsModalOpen(false);
        })
    }

    return (
        <div>
            VisitaEstudio


            <div className='columna'>

                <span>Seleccione el archivo de tratamiento</span>

                <Upload {...props}>
                    <Button icon={<UploadOutlined />}>Cargar estudios</Button>
                </Upload>

            </div>
            <br />
            <br />
            <div style={{ position: 'absolute', right: 16, bottom: 16 }}>
                <Button onClick={() => setIsModalOpen(false)} >Cancelar</Button>
                <Button type='primary' onClick={onConfirm}>Confirmar</Button>
            </div>

        </div>
    )
}
